var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_2571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7218 75.5941C64.0723 74.7587 62.8991 74.5436 61.9956 75.0946C49.2639 82.8888 32.6245 78.8863 24.8303 66.1546C17.0361 53.4229 21.0386 36.7835 33.7703 28.9893C36.9097 27.0673 40.4085 25.8069 44.0523 25.2852C45.0772 25.1381 45.8381 24.2602 45.8379 23.2249V6.24331C45.8379 5.09396 44.906 4.16214 43.7567 4.16214C19.6575 4.16214 0.0534668 25.6351 0.0534668 52.0275C0.0833177 78.4506 21.4959 99.8632 47.9188 99.8931C57.5127 100.639 66.999 97.464 74.2116 91.0941C75.0818 90.3781 75.2238 89.0994 74.5322 88.2097L64.7218 75.5941Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0812 20.8111C67.0152 20.8295 79.1173 32.9314 79.1356 47.8656C79.1356 49.0149 80.0674 49.9467 81.2168 49.9467H97.8656C99.0149 49.9467 99.9467 49.0149 99.9467 47.8656C99.9167 21.4425 78.5041 0.0298509 52.0812 0C50.9318 0 50 0.931815 50 2.08117V18.73C50 19.8793 50.9318 20.8111 52.0812 20.8111Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8654 54.1087H80.8877C79.8445 54.0982 78.9546 54.8616 78.8065 55.8943C77.869 62.4468 74.5571 68.4266 69.4999 72.6972C68.6256 73.4292 68.5031 74.7282 69.2252 75.6107L81.6618 91.0108C82.0247 91.4611 82.5585 91.7399 83.1353 91.7809H83.2976C83.8242 91.7813 84.3314 91.5819 84.717 91.2231C94.4171 82.1519 99.9298 69.4706 99.9466 56.1899C99.9466 55.0405 99.015 54.1087 97.8654 54.1087Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_2571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.1dd91d1ff9e7ae9b7cac8dc5847cc41f.svg";
export { ForwardRef as ReactComponent };